// ======================================================================
// File Name       : RoleDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE } from '../../constants/AuthorityConstant';
import { HYPHEN } from '../../constants';

class RoleDetail extends React.Component {
  /**
     * Get authority text by number
     * @param {number} authority
     * @return {string}
     */
  getAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '参照のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  /**
     * Get scoring authority text by number
     * @param {number} authority
     * @return {string}
     */
  getScoringAuthorityText(authority) {
    switch (authority) {
      case 1:
        return '採点のみ';
      case 2:
        return '全て可能';
      default:
        return HYPHEN;
    }
  }

  getAuthorityDisplayText(authority) {
    switch (authority) {
      case 0:
        return '非表示';
      case 1:
      case 2:
        return '表示';
      default:
        return '';
    }
  }

  getMaterialAuthorityText(authority) {
    switch (authority) {
      case 1:
        return 'ダウンロード可';
      default:
        return HYPHEN;
    }
  }

  /**
     * Life cycle function
     */
  shouldComponentUpdate(nextProps) {
    return nextProps.authority !== null;
  }

  /**
     * Render method of component
     */
  render() {
    const { isDetail } = this.props;
    const { superuserServiceRoleName, superuserServiceRoleSecernId, managementFunctionAuthorityInfo, managementFunctionAuthorityDisplayInfo } = this.props.authority;
    const leftColumn = isDetail ? 4 : 5;
    const rightColumn = isDetail ? 8 : 7;
    return (
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Row>
          <Form.Group>
            <Col sm={3} className="form-label">ロール識別ID</Col>
            <Col sm={9} className="padding-top-bottom-10">{superuserServiceRoleSecernId}</Col>
          </Form.Group>
          </Row>
          <Row>
          <Form.Group>
            <Col sm={3} className="form-label">ロール名</Col>
            <Col sm={9} className="padding-top-bottom-10">{superuserServiceRoleName}</Col>
          </Form.Group>
          </Row>
          <Form.Group>
            <Col sm={12} className="form-label"><p>画面表示</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">受講ユーザー管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={leftColumn} className="form-label">ユーザーグループ設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">コース</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">ビデオ/ドキュメント/リンク/ドリル</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">学習履歴</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">添削管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">メッセージ管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">お知らせ</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">メール連絡</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">受講ユーザー画面設定</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">システム利用実績管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">TOP画面ダウンロードボタン</Col>
                  <Col sm={rightColumn} className="form-label">
                    {this.getAuthorityDisplayText(
                      managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay,
                    )}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form.Group>
          <Form.Group>
            <Col sm={12} className="form-label margin-left-15"><p>権限設定</p></Col>
          </Form.Group>
          <Form.Group className="padding-left-50">
            <Form.Group>
              <Col sm={12} className="padding-left-50">
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">受講ユーザー管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.userManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.userManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  {/* Step10.0.0 START */}
                  <Col sm={leftColumn} className="form-label">ユーザーグループ設定</Col>
                  {/* Step10.0.0 END */}
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.groupManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.groupManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">コース</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.courseManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.courseManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">ビデオ/ドキュメント/リンク/ドリル</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.contentManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.contentManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">学習履歴</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.achievementManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.achievementManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">添削管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.scoringManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getScoringAuthorityText(
                          managementFunctionAuthorityInfo.scoringManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">メッセージ管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.messageManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getScoringAuthorityText(
                          managementFunctionAuthorityInfo.messageManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">お知らせ</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.noticeManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.noticeManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">メール連絡</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.emailManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.emailManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">受講ユーザー画面設定</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.userfrontManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.userfrontManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">システム利用実績管理</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.performanceManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getAuthorityText(
                          managementFunctionAuthorityInfo.performanceManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col sm={leftColumn} className="form-label">TOP画面ダウンロードボタン</Col>
                  <Col sm={rightColumn} className="form-label">
                    {
                      managementFunctionAuthorityDisplayInfo.materialManagementAuthorityDisplay === MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY ?
                        this.getMaterialAuthorityText(
                          managementFunctionAuthorityInfo.materialManagementAuthority,
                        ) : HYPHEN}
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default RoleDetail;
